<template>
  <div class="c-header-menu-mobile">
    <transition name="fade" appear>
      <div
        class="c-header-menu-mobile__background"
        v-show="isShow"
        @click="$emit('close-menu')"
      >
        <button
          class="c-header-menu-mobile__close-button"
          @click="$emit('close-menu')"
        >
          <i class="icon-x"></i>
        </button>
      </div>
    </transition>
    <transition name="slide-in">
      <div class="c-header-menu-mobile__container" v-show="isShow">
        <ul class="c-header-menu-mobile__header">
          <template v-if="accountName">
            <li class="c-header-menu-mobile__header-item">
              <a
                class="c-header-menu-mobile__header-link"
                :href="routes.mypage"
              >
                <i class="icon-man c-header-menu-mobile__header-icon"></i>
                {{ accountName }}さま
              </a>
            </li>

            <li class="c-header-menu-mobile__header-item half">
              <a class="c-header-menu-mobile__header-link" :href="routes.order">
                <i class="icon-history c-header-menu-mobile__header-icon"></i>
                購入履歴
              </a>
            </li>

            <li class="c-header-menu-mobile__header-item half">
              <a class="c-header-menu-mobile__header-link" :href="routes.fav">
                <i
                  class="icon-heart-outline c-header-menu-mobile__header-icon"
                ></i>
                お気に入り
              </a>
            </li>
          </template>

          <template v-else>
            <li class="c-header-menu-mobile__header-item half">
              <a class="c-header-menu-mobile__header-link" :href="routes.login">
                <i class="icon-man c-header-menu-mobile__header-icon"></i>
                ログイン
              </a>
            </li>

            <li class="c-header-menu-mobile__header-item half">
              <a
                class="c-header-menu-mobile__header-link"
                :href="routes.register"
              >
                <i class="icon-binder c-header-menu-mobile__header-icon"></i>
                新規会員登録
              </a>
            </li>

            <li class="c-header-menu-mobile__header-item">
              <a class="c-header-menu-mobile__header-link" :href="routes.fav">
                <i
                  class="icon-heart-outline c-header-menu-mobile__header-icon"
                ></i>
                お気に入り
              </a>
            </li>
          </template>
        </ul>

        <ul
          v-for="(block, index) in menuItems"
          :key="index"
          class="c-header-menu-mobile__menu-items"
        >
          <li
            v-for="item in block"
            class="c-header-menu-mobile__menu-item"
            :key="item.url"
          >
            <menu-item-mobile :menu-item="item" show-image></menu-item-mobile>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import MenuItemMobile from '~/js/components/header/menuItemMobile'

export default {
  name: 'ComponentHeaderMenuMobile',
  components: {
    MenuItemMobile,
  },
  props: {
    accountFirstName: { type: String, default: '' },
    accountLastName: { type: String, default: '' },
    categoryItems: { type: Array, default: () => [] },
    isShow: { type: Boolean, default: false },
    menuItems: { type: Array, default: () => [] },
    routes: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    accountName() {
      return [this.accountLastName, this.accountFirstName]
        .filter((v) => v)
        .join(' ')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-menu-mobile {
  &__background {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: auto;
    transition: 0.3s;

    &.fade-enter-from,
    &.fade-leave-to {
      opacity: 0;
    }
  }

  &__container {
    background-color: variables.$color-gray;
    position: fixed;
    top: 0;
    left: 0;
    width: 320px;
    height: 100vh;
    margin: auto;
    overflow: scroll;
    padding-bottom: 100px;
    transition: 0.3s;

    &.slide-in-enter-from,
    &.slide-in-leave-to {
      transform: translateX(-100%);
    }
  }

  &__close-button {
    color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
  }

  &__header {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 12px;
  }

  &__header-item {
    margin: 4px;
    width: 100%;

    &.half {
      width: calc(50% - 8px);
    }
  }

  &__header-link {
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: center;
  }

  &__header-icon {
    margin-right: 8px;
    font-size: 18px;
    line-height: 1;
  }

  &__menu-items {
    & + & {
      margin-top: 16px;
    }
  }
}
</style>
